import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { toast } from "react-toastify";
import firebase from "./../../firebase";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from "react-router-dom";

const MenageUser = () => {
    const { id } = useParams()
    const [schedule, setSchedule] = useState([]);
    const [filteredSchedule, setFilteredSchedule] = useState([]); // Liste filtrée
    const [searchQuery, setSearchQuery] = useState(""); // Requête de recherche

    const [isLoading, setIsLoading] = useState(false); // Indicateur de chargement
    const [selectedMonth, setSelectedMonth] = useState(-1); // Mois sélectionné (-1 = "Tous")
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Année sélectionnée (défaut à l'année en cours)
    const [availableYears, setAvailableYears] = useState([]); // Années disponibles



    function openInNewTab() {
        const newTab = window.open(`/menage/sync/${id}`, '_blank'); // Ouvre un nouvel onglet
        if (newTab) {
            newTab.focus(); // Met le nouvel onglet au premier plan
        } else {
            alert('Impossible d’ouvrir le nouvel onglet. Vérifiez les paramètres de votre navigateur.');
        }
    }

    const transformReservations = (reservations, villaIds) => {
        return reservations
            .filter((reservation) => {
                const villaId = reservation.property?.value || reservation.id;
                return villaIds.map((v) => { return v.value; }).includes(villaId); // Vérifie si le villaId est dans la liste des villaIds
            })
            .map((reservation) => {
                const villaId = reservation.property?.value || reservation.id;
                const villaName = reservation.property?.label || reservation.villa;
                const rawArrivalDate = reservation.checkin?.toDate();
                const rawDepartureDate = reservation.checkout?.toDate();

                const factureTo = reservation.factureTo || undefined; // Valeur par défaut si non défini
                const services = reservation.services || undefined; // Valeur par défaut si non défini
                const amount = reservation.amount || undefined; // Valeur par défaut si non défini


                return {
                    id: reservation.id,
                    villaId,
                    villaName,
                    arrivalDate: format(rawArrivalDate, "d MMMM yyyy", { locale: fr }),
                    departureDate: format(rawDepartureDate, "d MMMM yyyy", { locale: fr }),
                    factureTo,
                    services,
                    amount,
                    rawArrivalDate,
                    menages: reservation?.menages || [],
                };
            })
            .sort((a, b) => a.rawArrivalDate - b.rawArrivalDate); // Trier par date d'arrivée
    };

    const loadBooking = async () => {
        setIsLoading(true); // Démarre le chargement
        try {
            const snap = await firebase.firestore().collection("bookings").get();
            const reservations = [];
            const futureReservations = []; // Tableaux pour les réservations futures

            snap.forEach((doc) => {
                const data = doc.data();
                data.id = doc.id;
                if (!data.delete && data.statut?.value === "confirmed") {
                    reservations.push({ ...data, villa: data.property?.label });

                    // const departureDate = data.checkout?.toDate();
                    // if (departureDate && departureDate > new Date()) {
                    futureReservations.push(data); // Ajouter les réservations futures
                    // }
                }
            });
            let full = reservations;

            const doc = await firebase.firestore().collection('usersMenage').doc(id).get()

            let info = doc.data();
            const isIncludeVilla = (id) => {
                let isInclude = false;
                info.villas.forEach(v => {
                    if (v.value === id) {
                        isInclude = true;
                    }
                })
                return isInclude;

            }
            // on va ajouter les réservation des "Propriétaire dans les données unvailable"
            const docunavailable = await firebase.firestore().collection('dates').doc('unavailable').get()
            if (docunavailable.exists) {
                const unavailable = docunavailable.data()
                // const unavailableReservations = unavailable.dates
                const filteredData = unavailable.dates.filter(item => {
                    const message = item.message ? item.message.toString() : ""; // Évite les erreurs si message est null/undefined

                    const normalizedMessage = message
                        .toLowerCase()
                        .normalize("NFD") // Décompose les lettres accentuées en lettre + accent
                        .replace(/[\u0300-\u036f]/g, ""); // Supprime les accents

                    return normalizedMessage.includes("proprietaire") && isIncludeVilla(item.villaId); // Recherche sans accent
                });

                const getVillaName = (id, villas) => {
                    return villas.find((v) => v.value === id)?.label || "Villa inconnue";
                }

                let filteredDataM = filteredData.map(fd => {
                    return {
                        id: fd.id,
                        services: fd.message,
                        property: {
                            value: fd.villaId,
                            label: getVillaName(fd.villaId, info.villas)
                        },
                        checkin: {
                            toDate: () => {
                                return new Date(fd.startDate);
                            }
                        },
                        checkout: {
                            toDate: () => {
                                return new Date(fd.endDate);
                            }
                        }
                    }
                })
                full = reservations.concat(filteredDataM)
            }

            const transformed = transformReservations(full, info.villas);
            setSchedule(transformed);
            setFilteredSchedule(transformed); // Initialiser la liste filtrée avec toutes les réservations

            // Extraire les années disponibles à partir des réservations futures
            const yearsSet = new Set();
            futureReservations.forEach((reservation) => {
                const arrivalDate = reservation.checkin?.toDate();
                const departureDate = reservation.checkout?.toDate();
                if (arrivalDate) {
                    yearsSet.add(arrivalDate.getFullYear());
                }
                if (departureDate) {
                    yearsSet.add(departureDate.getFullYear());
                }
            });




            // Convertir en tableau et trier les années (seulement pour les réservations futures)
            setAvailableYears([...yearsSet].sort((a, b) => b - a)); // Tri décroissant

        } catch (error) {
            console.error("Erreur lors du chargement des réservations :", error);
            toast.error("Erreur lors du chargement des réservations.");
        } finally {
            setIsLoading(false); // Fin du chargement
        }
    };

    useEffect(() => {
        loadBooking();
    }, []);


    useEffect(() => {
        // On filtre d'abord en fonction de la recherche
        const lowercasedQuery = searchQuery.toLowerCase();
        let filtered = schedule.filter((item) => {
            return item.villaName.toLowerCase().includes(lowercasedQuery);
        });
        // console.log('filtered', filtered)
        // Si un mois est sélectionné (autre que "Tous"), on filtre aussi par mois et année
        if (selectedMonth !== -1) {
            filtered = filtered.filter((item) => {
                const arrivalDate = item.rawArrivalDate;
                const itemMonth = arrivalDate.getMonth(); // Mois de la réservation
                const itemYear = arrivalDate.getFullYear(); // Année de la réservation
                return itemMonth === selectedMonth && itemYear === selectedYear;
            });
        } else {
            // Si "Tous" est sélectionné, on filtre uniquement par année
            filtered = filtered.filter((item) => {
                const itemYear = item.rawArrivalDate.getFullYear();
                return itemYear === selectedYear;
            });
        }

        // Mise à jour de la liste filtrée
        setFilteredSchedule(filtered);
    }, [searchQuery, schedule, selectedMonth, selectedYear]);





    const months = [
        "Tous", "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];

    return (
        <div className="container">
            <h2 className="text-center mb-4">Planning de ménage</h2>

            {isLoading && (
                <div className="text-center mb-4">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Chargement...</span>
                    </div>
                </div>
            )}

            <div className="d-flex justify-content-center mb-3">
                <button onClick={openInNewTab}  >
                    Ajouter à mon téléphone
                </button>
            </div>

            {/* Sélecteur de mois et d'année */}
            <div className="d-flex justify-content-center mb-3">
                <select
                    className="form-control mx-2"
                    value={selectedMonth}
                    onChange={(e) => setSelectedMonth(Number(e.target.value))}
                >
                    {months.map((month, index) => (
                        <option key={index} value={index - 1}>
                            {month}
                        </option>
                    ))}
                </select>
                <select
                    className="form-control mx-2"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(Number(e.target.value))}
                >
                    {availableYears.map((year) => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
                </select>
            </div>

            {/* Barre de recherche */}
            <div className="mb-3 mx-2">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Rechercher une villa..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>

            {/* Affichage pour mobile */}
            <div className="d-block d-md-none">
                {/* Affichage pour mobile : liste de cartes */}
                {filteredSchedule.map((item) => (
                    <>
                        <div className="card mb-3" key={item.id}>
                            <div className="card-body">
                                <h5 className="card-title">{item.villaName}</h5>
                                <p className="card-text">
                                    <strong>Arrivée : </strong> {item.arrivalDate}
                                    <br />
                                    <strong>Départ : </strong> {item.departureDate}
                                    <br />
                                    {/* Champ "Facturé à" */}
                                    <strong>Facturé à : </strong>
                                    <>
                                        {item.factureTo ? (
                                            <span>{item.factureTo}</span>
                                        ) : (
                                            <span className="text-muted">Non défini</span>
                                        )}
                                    </>
                                    <br />

                                    {/* Champ "Services" */}
                                    <strong>Services : </strong>
                                    <>
                                        {item.services ? (
                                            <span>{item.services}</span>
                                        ) : (
                                            <span className="text-muted">Non défini</span>
                                        )}
                                    </>
                                    <br />

                                    {/* Champ "Montant" */}
                                    <strong>Montant : </strong>
                                    <>
                                        {item.amount ? (
                                            <span>{item.amount}</span>
                                        ) : (
                                            <span className="text-muted">Non défini</span>
                                        )}
                                    </>
                                </p>
                            </div>
                        </div>

                        {item.menages?.map((menage, index) => {
                            const datestart = new Date(menage.startDate);
                            const formattedDate = format(datestart, "d MMMM yyyy à HH:mm", { locale: fr });


                            const dateend = new Date(menage.endDate);
                            const formattedDateEnd = format(dateend, "d MMMM yyyy à HH:mm", { locale: fr });
                            return (

                                <div className="card mb-3" key={`${item.id}_${index}`}>
                                    <div className="card-body">
                                        <h5 className="card-title">{item.villaName} (Ménage)</h5>
                                        <p className="card-text">
                                            <strong>Arrivée : </strong> {formattedDate}
                                            <br />
                                            <strong>Départ : </strong> {formattedDateEnd}
                                            <br />
                                            <strong>Facturé à : </strong>
                                            <span>--</span>
                                            <br />

                                            <strong>Services : </strong>
                                            <span>{menage.title}</span>
                                            <br />

                                            <strong>Montant : </strong>
                                            <span>--</span>
                                        </p>
                                    </div>
                                </div>
                            )
                        })}
                    </>

                ))}
            </div>

            {/* Affichage pour écrans moyens et grands */}
            <div className="table-responsive d-none d-md-block">
                <table className="table table-striped table-hover">
                    <thead className="table-dark">
                        <tr>
                            <th scope="col">Villa</th>
                            <th scope="col">Arrivée</th>
                            <th scope="col">Départ</th>
                            <th scope="col">Facturé à</th>
                            <th scope="col">Services</th>
                            <th scope="col">Montant (€)</th>

                        </tr>
                    </thead>
                    <tbody>
                        {filteredSchedule.map((item, index) => (
                            <>
                                <tr key={item.id}>
                                    <td>{item.villaName}</td>
                                    <td>{item.arrivalDate}</td>
                                    <td>{item.departureDate}</td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            {item.factureTo ? (
                                                <span className="me-2">{item.factureTo}</span>
                                            ) : (
                                                <span className="text-muted">Non défini</span>
                                            )}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            {item.services ? (
                                                <span className="me-2">{item.services}</span>
                                            ) : (
                                                <span className="text-muted">Non défini</span>
                                            )}
                                        </div>
                                    </td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            {item.amount ? (
                                                <span className="me-2">{item.amount}</span>
                                            ) : (
                                                <span className="text-muted">Non défini</span>
                                            )}
                                        </div>
                                    </td>

                                </tr>
                                {item.menages?.map((menage, index) => {
                                    const datestart = new Date(menage.startDate);
                                    const formattedDate = format(datestart, "d MMMM yyyy à HH:mm", { locale: fr });


                                    const dateend = new Date(menage.endDate);
                                    const formattedDateEnd = format(dateend, "d MMMM yyyy à HH:mm", { locale: fr });
                                    return (
                                        <tr key={`${item.id}_${index}`}>
                                            <td>{item.villaName} (Ménage)</td>
                                            <td>{formattedDate}</td>
                                            <td>{formattedDateEnd}</td>
                                            <td>
                                                --
                                            </td>
                                            <td>
                                                {menage.title}
                                            </td>
                                            <td>
                                                --
                                            </td>
                                        </tr>
                                    )
                                })}
                            </>
                        ))}
                    </tbody>

                </table>
            </div>
        </div>
    );
};

export default MenageUser;